import AsyncStorage from '@react-native-async-storage/async-storage';
import type { MixpanelClient } from './mixpanel';

export const ANALYTICS_CONSENT_KEY = 'analytics_consent';

const DEFAULT_CONSENT_TIMEOUT_MS = 3000;

let lastKnownConsent: boolean | undefined;

export async function getAnalyticsConsent(): Promise<boolean> {
  try {
    const stored = await AsyncStorage.getItem(ANALYTICS_CONSENT_KEY);
    const consent = stored !== 'denied';
    lastKnownConsent = consent;
    return consent;
  } catch {
    return lastKnownConsent ?? true;
  }
}

export interface ConsentResolution {
  granted: boolean;
  provisional: boolean;
}

export async function getAnalyticsConsentWithin(
  timeoutMs: number = DEFAULT_CONSENT_TIMEOUT_MS,
  onLateResolution?: (lateValue: boolean) => void,
): Promise<ConsentResolution> {
  const DEFAULT_ON_TIMEOUT = true;
  const consentPromise = getAnalyticsConsent();
  let timedOut = false;

  const granted = await Promise.race([
    consentPromise,
    new Promise<boolean>((resolve) =>
      setTimeout(() => {
        timedOut = true;
        resolve(DEFAULT_ON_TIMEOUT);
      }, timeoutMs),
    ),
  ]);

  if (timedOut && onLateResolution) {
    consentPromise.then(onLateResolution);
  }

  return { granted, provisional: timedOut };
}

export async function setAnalyticsConsent(enabled: boolean): Promise<void> {
  try {
    await AsyncStorage.setItem(ANALYTICS_CONSENT_KEY, enabled ? 'granted' : 'denied');
    lastKnownConsent = enabled;
  } catch {}
}

export function bootstrapMixpanelConsent(
  client: MixpanelClient,
  granted: boolean,
  flushBuffered: () => void,
): void {
  if (granted) {
    flushBuffered();
    return;
  }
  client.optOutTracking();
}
